import { Component, OnInit, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ApplicationType } from 'src/api/models/application-type';
import { AzureAuthService } from 'src/service/azure-auth.service';
import { ApplicationConfigService } from 'src/service/application-config.service';
import { ApplicationService,CustomerService,CeresTagService } from 'src/api/services';
import { CustomerApplication } from 'src/api/models';


@Component({
  selector: 'app-ceres-tag-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class CeresTagHomeComponent implements OnInit {

  public config: any;
  public application : CustomerApplication;
  public newFarmName: string;

  constructor(
    private service: ApplicationService,
    private app: ApplicationConfigService,
    public azureAuthService: AzureAuthService,
    public customerService: CustomerService,
    private toasterService: ToastrService,
    private ceres: CeresTagService) { 
      app.customerChanged$.subscribe(cid => {
        this.ngOnInit();
      });
  }

  ngOnInit(): void {    
    if (this.azureAuthService.isAdmin()){
      if (this.app.customers == null){
        this.customerService.CustomerGetAllCustomers().subscribe(c => { 
          this.app.customers = c;
          this.loadCustomer();
        });
      }else{
        this.loadCustomer();
      }
    } else {
      if (this.app.customerId == null) {
        this.app.customerId = this.azureAuthService.userProfile.customerId;
      }
      this.loadCustomer();
    }
  }

  loadCustomer(){
    this.ceres.CeresTagGet(this.app.customerId).subscribe(s => {
      this.application = s;

      this.config = this.application.applicationConfiguration;
    });
  }

  changeCustomer(){
    this.loadCustomer();
  }

  enable(){
    this.ceres.CeresTagPurchase(this.app.customerId).subscribe(s => {
      this.application = s;
      this.config = this.application.applicationConfiguration;
    });
  }

  activeIndiciumCloud(farm){
    this.ceres.CeresTagSetupIndiciumCloud({farmId: farm.identifier, customerId: this.app.customerId}).subscribe(s => {
      this.toasterService.info("Active");
      farm.setupInCloud = true; 
    });
  }

  deleteFarm(farm){
    if (confirm("Are you sure you want to remove this farm? This cannot be undone!")){
      this.ceres.CeresTagDelete({farmId: farm.identifier, customerId: this.app.customerId}).subscribe(r => {
        this.toasterService.info("Farm Deleted");
        var i = this.config.farms.indexOf(farm);
        this.config.farms.splice(i, 1);
      }, err => {
        this.toasterService.error("Farm Not Deleted")
      });
    }
  }

  addFarm(){
    this.ceres.CeresTagAddFarm({farmName: this.newFarmName, customerId: this.app.customerId}).subscribe(r => {
      this.toasterService.info("New Farm Added");
      this.config.farms.push(r);
    }, err => {
      this.toasterService.error("New Farm Not Added")
    });
  }
}
